import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal mediaViewer"
}
const _hoisted_2 = { class: "modal--content autoAdjust" }
const _hoisted_3 = { class: "modal--header" }
const _hoisted_4 = {
  key: 0,
  class: "modal--body"
}
const _hoisted_5 = {
  key: 0,
  class: "shimmer_container"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_LogoShimmerComponent = _resolveComponent("LogoShimmerComponent")!

  return (_ctx.file)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal--backdrop",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", null, "Preview: " + _toDisplayString(_ctx.file.name), 1),
            _createVNode(_component_IconComponent, {
              path: "",
              className: "closebtn",
              icon: "close-times.svg",
              onClick: _ctx.dismiss
            }, null, 8, ["onClick"])
          ]),
          (_ctx.url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (!_ctx.isLoaded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_LogoShimmerComponent)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isWidgetShown)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.isDocViewer)
                        ? (_openBlock(), _createElementBlock("iframe", {
                            key: 0,
                            src: _ctx.url,
                            onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isLoaded = true)),
                            onError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reload())),
                            loading: "lazy",
                            frameborder: "0"
                          }, null, 40, _hoisted_6))
                        : (_ctx.isImageViewer || _ctx.isVideoViewer)
                          ? (_openBlock(), _createElementBlock("figure", _hoisted_7, [
                              (_ctx.isImageViewer)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    onError: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reload())),
                                    onLoad: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isLoaded = true)),
                                    src: _ctx.url
                                  }, null, 40, _hoisted_8))
                                : _createCommentVNode("", true),
                              (_ctx.isVideoViewer)
                                ? (_openBlock(), _createElementBlock("video", {
                                    key: 1,
                                    onLoad: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isLoaded = true)),
                                    onError: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reload())),
                                    controls: "",
                                    style: {"width":"100%"}
                                  }, [
                                    _createElementVNode("source", { src: _ctx.url }, null, 8, _hoisted_9)
                                  ], 32))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}